import React, { useState } from 'react';
import { Select } from 'antd';

import moment from 'moment';
import 'antd/dist/antd.css'; // Import Ant Design styles

import { BACKYEARS } from '../../constants/constants.js'

const { Option } = Select;

const LeapYear = year => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

const generateYears = () => {
    const years = [];
    const currentYear = new Date().getFullYear();

    for (let year = currentYear; year >= currentYear - BACKYEARS; year--) {
        years.push(year);
    }

    return years;
}

const monthNames = [
    { name: "January", value: "01" },
    { name: "February", value: "02" },
    { name: "March", value: "03" },
    { name: "April", value: "04" },
    { name: "May", value: "05" },
    { name: "June", value: "06" },
    { name: "July", value: "07" },
    { name: "August", value: "08" },
    { name: "September", value: "09" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" }
];

const generateDays = (month, year) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentDay = new Date().getDate();

    const monthIndex = month ? parseInt(month, 10) - 1 : currentMonth; // Convert month string to zero-based index

    if (year === currentYear && monthIndex === currentMonth) {
      return Array.from({ length: currentDay }, (_, i) => String(i + 1).padStart(2, '0'));
    }
  
    if (monthIndex === 1 && LeapYear(year)) { // February and it's a leap year
      return Array.from({ length: 29 }, (_, i) => String(i + 1).padStart(2, '0'));
    }
  
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate(); // Get the number of days in the specified month
    return Array.from({ length: daysInMonth }, (_, i) => String(i + 1).padStart(2, '0'));
  };
  


const DatePicker = (props) => {
    const [day, setDay] = useState("");
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");

    const formatDate = (day, month, year) => {
        let date = year + "-" + month + "-" + day;
        let mommentDate = moment(date); 
        // let formatedDate = moment(new Date(date));

        var formatedDate = mommentDate.format("YYYY-MM-DD, h:mm:ss");

        return formatedDate;
    }

    const handleDayChange = value => {
        setDay(value);
        if (value !== "" && month !== "" && year !== "") {
            let formatedDate = formatDate(value, month, year)
            props.onChange(formatedDate)
        }
    };

    const handleMonthChange = value => {
        setMonth(value);
        if (day !== "" && value !== "" && year !== "") {
            let formatedDate = formatDate(day, value, year)
            props.onChange(formatedDate)
        }
    };

    const handleYearChange = value => {
        setYear(value);
        if (day !== "" && month !== "" && value !== "") {
            let formatedDate = formatDate(day, month, value)
          //  console.log("Parag ", formatedDate)
            props.onChange(formatedDate)
        }
    };


    const years = generateYears();
    const days = generateDays(month, year);

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    return (
        <div>
            <Select className={props.className} value={day} onChange={handleDayChange} style={{ width: 70 }} placeholder="Select Date">
                <Option value="" disabled>Date</Option>
                {days.map((day, index) => (
                    <Option key={index} value={day}>{day}</Option>
                ))}
            </Select>
            <Select className={props.className} value={month} onChange={handleMonthChange} style={{ width: 115, padding: "0px 5px" }} placeholder="Select Month">
                <Option value="" disabled>Month</Option>
                {monthNames.map(({ name, value }, index) => (
                    <Option key={index} value={value} disabled={year === currentYear && parseInt(value, 10) > currentMonth + 1}>{name}</Option>
                ))}
            </Select>
            <Select className={props.className} value={year} onChange={handleYearChange} style={{ width: 100 }} placeholder="Select Year">
                <Option value="" disabled>Year</Option>
                {years.map((year, index) => (
                    <Option key={index} value={year} disabled={year > currentYear}>{year}</Option>
                ))}
            </Select>
        </div>
    );
};

export default DatePicker;
